import React from 'react';
import { Popconfirm, message } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Sider from '../SiteSider';
import Update from './components/Update';
import Filter from './components/Filter';
import moment from 'moment';
import TransferStationRecord from '../../hospital/doctorInfo/TransferStationRecord';
import format from '../../shared/format';
import { Gender, PiIdentity } from './constants';

class PiInfo extends React.Component {
    state = {
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
        data: [],
        sortParams: {},
        searchParams: {},
    }

    componentDidMount() {
        this.loadData();
        this.queryInvestigationStageByInvId();
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: { ...params },
        }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            method: 'POST',
            url: API_URL.user.queryPIList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { PIList: { datas, totalCount } } = res.data;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    delete = (userId, invSiteId, memberId) => {
        const options = {
            url: API_URL.user.removePI,
            data: {
                userId,
                memberId,
                invSiteId,
            },
            dataType: 'json',
            doneResult: () => {
                message.success("删除成功");
                this.loadData();
            },
        };
        $.sendRequest(options);
    }
    
    //转岗记录
    showTransferStationRecord = record => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryChangeDoctorPost,
            data: {
                userId: record.doctorPostId,
            },
            dataType: 'json',
            doneResult: res => {
               this.showTransferStationRecordRef.show(res.data);
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId: invId },
            dataType: 'json',
            doneResult: res => {
                this.setState({ invStageList: res.data });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const columns = [{
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            fixed: 'left',
            width: 80,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 200,
        }, {
            title: '中心科室名称',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 100,
        }, {
            title: '参与临床试验人员姓名',
            dataIndex: 'userName',
            key: 'userName',
            width: 80,
        },  {
            title: '临床项目身份',
            dataIndex: 'piIdentity',
            key: 'piIdentity',
            width: 100,
            render: text=> PiIdentity[text]
        }, {
            title: '所在科室',
            dataIndex: 'hospitalDepartmentName',
            key: 'hospitalDepartmentName',
            width: 100,
        }, {
            title: '性别',
            dataIndex: 'gender',
            key: 'gender',
            width: 60,
            render: text => Gender[text]
        }, {
            title: '出生日期',
            dataIndex: 'birthDate',
            key: 'birthDate',
            width: 100,
            render: text => format('date', text)
        }, {
            title: '专业技术职称',
            dataIndex: 'professionalTitle',
            key: 'professionalTitle',
            width: 100,
        }, {
            title: '职务',
            dataIndex: 'doctorPosition',
            key: 'doctorPosition',
            width: 100,
        }, {
            title: '手机号码',
            dataIndex: 'mobile',
            key: 'mobile',
            width: 100,
        }, {
            title: '固定电话',
            dataIndex: 'telephone',
            key: 'telephone',
            width: 100,
        }, {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            width: 120,
        },{
            title: '在岗状态',
            dataIndex: 'postStatus',
            key: 'postStatus',
            width: 80,
            render: (text, record) => {
                const { postStatus, postEndTime } = record;
                return (
                    <span> 
                        {
                            postStatus == "ON" ?                   
                                <p>在岗</p>
                            :
                                <a onClick={() => this.showTransferStationRecord(record)}>
                                    转岗({moment(postEndTime).format('YYYY-MM-DD')})
                                </a>
                        }
                    </span>
                );
            },
        }];
        const { curRole, invState } = sessionStorage;
        if (curRole == 'PA' || curRole == 'PM' || (curRole == 'CTA' && invState == 3)) {
            columns.push({
                title: '操作',
                key: 'operation',
                fixed: 'right',
                width: 100,
                render: (text, record) => {
                    const { userId, invSiteId, memberId, reference } = record;
                    return (
                        reference ?
                            '-'
                        :
                            <span>
                                <a onClick={() => this.update(record, 'edit')}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title='确定要删除吗?' onConfirm={() => this.canEditByInvStatus(() => this.delete(userId, invSiteId, memberId))} okText="确定" cancelText="取消">
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                    );
                }
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => {
            const { memberId, user = {}, investigationSite, reference } = item;
            const { userName } = user || {};
            const { 
                hospitalName, 
                investigationSiteId, 
                investigationSiteCode, 
                investigationSiteName, 
                hospitalDepartmentName,
                departmentName,
            } = investigationSite || {};
            return {
                ...user,
                memberId,
                reference,
                hospitalName,
                investigationSiteCode,
                investigationSiteName,
                hospitalDepartmentName,
                departmentName,
                userCompellation: userName,
                invSiteId: investigationSiteId,
            };
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    update = (record, type) => {
        this.canEditByInvStatus(() => this.updateRef.show(record, type));
    }

    render() {
        const { loading, pagination, sortParams } = this.state;
        return (
            <div className="content">
                <Sider selectKey='sitePi' />
                <div className="main">
                    <Filter search={this.search} update={this.update} />
                    <div className="content">
                        <TableC
                            columns={this.getColumns()}
                            data={this.getDataSource()}
                            rowKey="memberKey"
                            loading={loading}
                            sortParams={sortParams}
                            onChange={this.handleTableChange}
                            pagination={ pagination }
                        />
                        <Update ref={el => this.updateRef = el} loadData={this.loadData} />
                        <TransferStationRecord  ref={el => this.showTransferStationRecordRef = el} loadData={this.loadData}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default PiInfo;



// WEBPACK FOOTER //
// ./src/components/site/piInfo/index.js